export { GamesPlayedCell } from './GamesPlayedCell.tsx';
